import { styled } from '@mui/material'
import Typography, { TypographyProps } from '@mui/material/Typography'
import React from 'react'

import ExternalLink from '@/app/component/atom/external-link'
import { TWhatsappLocationContent } from '@/app/types/whatsapp'

type Props = TypographyProps & {
  location: TWhatsappLocationContent
}

const WhatsappLocation: React.FC<Props> = ({ location, ...props }) => {
  const { label, address, latitude, longitude } = location
  return (
    <StyledTypography {...props}>
      📍 Location: <strong>{label}</strong>
      {address ? ` - ${address}` : ''}{' '}
      {latitude && longitude && (
        <ExternalLink
          href={`https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=16/${latitude}/${longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          View location
        </ExternalLink>
      )}
    </StyledTypography>
  )
}

const StyledTypography = styled(Typography)({
  whiteSpace: 'pre-line',
})

export default WhatsappLocation
